export const DELIVERY_STATES_ENDPOINT = '/states';
export const DELIVERY_ZIPCODES_ENDPOINT = '/zipcodes';
export const DELIVERY_ZIPCODES_BY_ID_ENDPOINT = (zipCode: string) =>
  `${DELIVERY_ZIPCODES_ENDPOINT}/${zipCode}`;
export const DELIVERY_UTILITIES_BY_STATE_ENDPOINT = (state: string) =>
  `${DELIVERY_STATES_ENDPOINT}/${state}/utilities`;
export const DELIVERY_UTILITY_BY_ID_ENDPOINT = (utilityId: string) => `/utilities/${utilityId}`;
export const DELIVERY_UTILITIES_BY_ZIP_CODE_ENDPOINT = (zipCode: string) =>
  `${DELIVERY_ZIPCODES_ENDPOINT}/${zipCode}/utilities`;
